export default {
  NewsCard: () => import("./NewsCard"),
  ProductCard: () => import("./ProductCard"),
  CampaignCard: () => import("./CampaignCard"),
  UserCard: () => import("./UserCard"),
  RewardCard: () => import("./RewardCard"),
  SaleCard: () => import("./SaleCard"),
  PurchaseCard: () => import("./PurchaseCard")
};
